import { createContext, useContext } from 'react';

import { ApiServices } from '.';

export const ServicesContext = createContext<ApiServices>(undefined);
export const useServices = (): ApiServices => useContext<ApiServices>(ServicesContext);
